import React from "react";
import "./_nav-shopping.scss";
export const NavShopping = ({ children, title }) => {
  return (
    <nav className="nav-shopping">
      <span className="h4">{title}</span>
      {children}
    </nav>
  );
};
